import { Outlet } from "react-router-dom"
import { Navbar } from "./navbar"

export function AppLayout() {
  return (
    <div className="flex h-screen flex-col">
      <Navbar />
      <main className="flex-1 overflow-hidden">
        <Outlet />
      </main>
    </div>
  )
}
